import { ReactNode } from "react";
import { SettingsAccount } from "./SettingsAccount";
import { SettingsBilling } from "./SettingsBilling";
import { SettingsIntegrations } from "./SettingsIntegrations";
import { SettingsCheckout } from "./SettingsCheckout";
import { SettingsWebsiteDesign } from "./SettingsWebsiteDesign";
import { SettingsEmail } from "./SettingsEmail";
import { SettingsAi } from "./SettingsAi";

export const SETTINGS_TAB_PATHS: Record<string, string> = {
  account: "/settings/account",
  billing: "/settings/billing",
  integrations: "/settings/integrations",
  checkout: "/settings/checkout",
  website: "/settings/website",
  email: "/settings/email",
  ai: "/settings/ai",
};

export function getCurrentSettingsTab(pathname: string): string {
  if (pathname.includes("/integrations")) return "integrations";
  if (pathname.includes("/checkout")) return "checkout";
  if (pathname.includes("/website")) return "website";
  if (pathname.includes("/email")) return "email";
  if (pathname.includes("/ai")) return "ai";
  if (pathname.includes("/billing")) return "billing";
  if (pathname.includes("/account")) return "account";
  return "account";
}

export function getSettingsTabs({
  integrationsContent,
  billingContent,
}: {
  integrationsContent?: ReactNode;
  billingContent?: ReactNode;
} = {}): Array<{ value: string; label: string; content: ReactNode }> {
  return [
    { value: "account", label: "Account", content: <SettingsAccount /> },
    { value: "billing", label: "Billing", content: billingContent ?? <SettingsBilling /> },
    {
      value: "integrations",
      label: "Integrations",
      content: integrationsContent ?? <SettingsIntegrations />,
    },
    { value: "checkout", label: "Checkout", content: <SettingsCheckout /> },
    { value: "website", label: "Website", content: <SettingsWebsiteDesign /> },
    { value: "email", label: "Email", content: <SettingsEmail /> },
    { value: "ai", label: "AI", content: <SettingsAi /> },
  ];
}
